module.exports = __webpack_public_path__ + "static/media/resume-quan-vo-official.e907529e.pdf";